import React from 'react'

import styles from './SectionHeader.module.css'

const SectionHeader = ({ title, children }) => {
  return (
    <div className={styles.title}>
      {title}
      {children}
    </div>
  )
}

export default SectionHeader
